module.exports = __webpack_public_path__ + "img/pulled_chicken.dc240019.jpg";